import { render, staticRenderFns } from "./swiperBanner.vue?vue&type=template&id=792f3072&scoped=true"
import script from "./swiperBanner.vue?vue&type=script&lang=js"
export * from "./swiperBanner.vue?vue&type=script&lang=js"
import style0 from "./swiperBanner.vue?vue&type=style&index=0&id=792f3072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792f3072",
  null
  
)

export default component.exports